<template>
	<div class="measure-calories">
		<div class="date-time">
			<span class="date">{{ date(value.datetime) }}</span>
			<span class="time">{{ time(value.datetime) }}</span>
		</div>
		<div class="value"><span>{{ value.values.latitude }}</span> lat<br><span>{{ value.values.longitude }}</span> lng</div>
		<div class="svg">
			<d3-generic :value="100" icon="geo fencing" :domain="domain"/>
		</div>
		<div></div>
	</div>
</template>

<script>
import D3Generic from '../../../shared/widgets/measure/D3Generic'
export default {
	components: {
		D3Generic
	},
	props: [
		'value'
	],
	data () {
		return {
			domain: {
				min: 0,
				max: 100
			}
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('D MMM')
		},
		time (date) {
			return this.$moment(date).format('HH:mm')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/geofencing/widgets/measure/MeasurePosition.vue